module.exports = __webpack_public_path__ + "media/img/seed/13-8c5528e685a750fe0d5b9b491695469a.jpeg";